<template>
  <div class="flex items-center gap-x-2 p-2 font-bold">
    <FontAwesomeIcon
      v-if="icon"
      :icon="icon"
    />
    <button
      class="whitespace-nowrap text-lg"
      @click.stop="emits('click')"
    >
      {{ label }}
    </button>
  </div>
</template>

<script setup lang="ts">
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

interface IProps {
  label: string
  icon?: string
}

defineProps<IProps>()

const emits = defineEmits([ 'click' ])
</script>

<style scoped lang="scss">

</style>